(function () {
    function findElementInShadowRoots(selector, root) {
        root = root || document;

        var element = root.querySelector(selector);

        if (element) {
            return element;
        }

        var allElements = root.querySelectorAll('*');

        for (var i = 0; i < allElements.length; i++) {
            if (allElements[i].shadowRoot) {
                var shadowElement = findElementInShadowRoots(
                    selector,
                    allElements[i].shadowRoot
                );

                if (shadowElement) {
                    return shadowElement;
                }
            }
        }

        return null;
    }

    function openShopifyForm() {
        var teaser = findElementInShadowRoots(
            '[data-testid="form-teaser"]'
        );

        if (teaser) {
            teaser.click();
            return;
        }

        var attempts = 0;
        var maximumAttempts = 20;

        var searchInterval = window.setInterval(function () {
            attempts++;

            teaser = findElementInShadowRoots(
                '[data-testid="form-teaser"]'
            );

            if (teaser) {
                window.clearInterval(searchInterval);
                teaser.click();
                return;
            }

            if (attempts >= maximumAttempts) {
                window.clearInterval(searchInterval);

                console.warn(
                    'The Shopify Forms teaser could not be found.'
                );
            }
        }, 250);
    }

    document.addEventListener('click', function (event) {
        var link = event.target.closest('a');

if (!link) return;

var url = new URL(link.href, window.location.href);

if (url.hash !== '#open-shopify-form') return;

event.preventDefault();
openShopifyForm();
    });
})();